import { find, get, isEmpty, toLower } from "lodash";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { SearchableList, LoaderWrapper } from "..";
import { useDeepEffect, useRequest } from "../../abstracts";
import {
  GetRecordKeepers,
  GetSourceName,
  SaveRecordKeepers,
  SaveSourceName,
  SaveMasterSourceName,
  GetMasterSourceNames,
} from "../../services";
import { FieldInput } from "..";
import { errors, tranformListToDropdownValues } from "../../utils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useCallback } from "react";

const SourceDropdown = ({
  data,
  onSelect,
  value,
  setData,
  setFieldValueOuter,
  payLoad,
}) => {
  const savePayload = payLoad;
  const [newSourceName, setnewSourceName] = useState();
  const loading = false;
  const location = useLocation();

  const alreadyExist = (val) => {
    const temp = data.map((item) => {
      if (toLower(item.label) === toLower(val?.trim())) return true;
      else return false;
    });
    return temp.includes(true);
  };
  const schema = Yup.object().shape({
    sourceId: Yup.string()
      .required(errors.SourceName.required)
      .test(
        "newsourcename",
        errors.SourceName.alreadyExist,
        (val) => !alreadyExist(val)
      ),
  });
  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };
  useDeepEffect(
    () => {
      if (!loading) {
        if (newSourceName) {
          const filteredValue = find(
            data,
            (item) => toLower(item.name) === toLower(newSourceName)
          );
          onSelect(
            get(filteredValue, "id", ""),
            get(filteredValue, "name", "")
          );
        }
        setData(tranformListToDropdownValues(data || [], "name", "id"));
      }
    },
    [loading],
    true
  );
  const onFormSubmit = (values) => {
    savePayload.sourceName = values["sourceId"];
    SaveMasterSourceName(savePayload).then((response) => {
      GetMasterSourceNames(payLoad).then((res) => {
        setData(
          res.map((option) => ({
            value: option.name,
            label: option.name,
          }))
        );
        setFieldValueOuter("sourceId", res[res.length - 1].id);
        setFieldValueOuter("source", res[res.length - 1].name);
      });
    });
  };

  return (
    <>
      <LoaderWrapper isLoading={loading} loaderText="">
        <Formik
          initialValues={{
            newSourceName: "",
          }}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
          onSubmit={onFormSubmit}
        >
          {({ handleChange, handleSubmit, values }) => {
            return (
              <>
                <div className="dropdside-custom-dropdown">
                  <div>
                    <SearchableList
                      height="200px"
                      label="Select the source name"
                      options={data}
                      onSelect={onSelect}
                      selectedValue={value}
                    />
                  </div>
                  <div className="line-separator"></div>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="emppopvalid">
                      <Field
                        label="Add custom source name :"
                        name={"sourceId"}
                        type="text"
                        maxLength={30}
                        className="add-classification-field"
                        value={values["sourceId"]}
                        onChange={handleChange}
                        autoComplete="nope"
                        component={FieldInput}
                        placeholder={"Source name"}
                        onKeyDown={keyDown}
                      />
                    </div>
                    <Form.Group>
                      <Button type="Submit">Add</Button>
                    </Form.Group>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default SourceDropdown;
